export const ATTRIBUTE = {
  ALT_TEXT: 'altText',
  BARCODE: 'barcode',
  CAP: 'cap',
  CASE_SIZE: 'caseSize',
  CATEGORY: 'category',
  CHARGE_TAX: 'chargeTax',
  CHAR_COUNT_MAX: 'charCountMax', // TODO: delete with VELA_FEATURE_FLAG_ETSY_PERSONALIZATION_QUESTIONS
  COLLECTIONS: 'collections',
  CONDITION: 'condition',
  CONTINUE_SELLING: 'continueSelling',
  COUNTRY: 'country',
  COUNTRY_CODE: 'countryCode',
  CPI: 'cpi',
  DEADLINE_DATE: 'deadlineDate',
  DEFAULT_VALUE: 'defaultValue',
  DEPTH: 'depth',
  DESCRIPTION: 'description',
  DIGITAL: 'digital',
  DISTANCE_UNIT: 'distanceUnit',
  END_DATE: 'endDate',
  FILES: 'files',
  GTIN: 'gtin',
  HEIGHT: 'height',
  HS_CODE: 'hsCode',
  INSTRUCTIONS: 'instructions', // TODO: delete with VELA_FEATURE_FLAG_ETSY_PERSONALIZATION_QUESTIONS
  INTERNATIONAL_PRICING: 'internationalPricing',
  IRREGULAR: 'irregular',
  IS_SUPPLY: 'isSupply',
  ITEM_CATEGORY: 'itemCategory',
  ITEM_SPECIFICS: 'itemSpecifics',
  KEEP_ACTIVE: 'keepActive',
  KEYWORDS: 'keywords',
  LENGTH: 'length',
  LOCATION: 'location',
  MASS_UNIT: 'massUnit',
  MATERIALS: 'materials',
  META_DESCRIPTION: 'metaDescription',
  MINIMUM_ORDER_QUANTITY: 'minimumOrderQuantity',
  PAGE_TITLE: 'pageTitle',
  PAYMENT_POLICY: 'paymentPolicy',
  PERSONALIZATION: 'personalization',
  PER_STYLE_MINIMUM_ORDER_QUANTITY: 'perStyleMinimumOrderQuantity',
  PHOTOS: 'photos',
  PHYSICAL: 'physical',
  POSTAL_CODE: 'postalCode',
  PREORDER: 'preorder',
  PRICE: 'price',
  PROCESSING_PROFILE: 'processingProfile',
  PRODUCTION_PARTNERS: 'productionPartners',
  PRODUCT_DETAILS: 'productDetails',
  PRODUCT_TYPE: 'productType',
  PROFILE_ID: 'profileId',
  PROFILE_TYPE: 'profileType',
  QUANTITY: 'quantity',
  RESTOCK_DATE: 'restockDate',
  RETAIL_PRICE: 'retailPrice',
  RETURN_POLICY: 'returnPolicy',
  SECTION: 'section',
  SELLING_METHOD: 'sellingMethod',
  SEO: 'seo',
  SHIPPING: 'shipping',
  SHIPPING_POLICY: 'shippingPolicy',
  SHOULD_AUTO_RENEW: 'shouldAutoRenew',
  SKU: 'sku',
  START_DATE: 'startDate',
  STORE_CATEGORY: 'storeCategory',
  TAGS: 'tags',
  TARIFF_CODE: 'tariffCode',
  TAXONOMY_ATTRIBUTES: 'taxonomyAttributes',
  TITLE: 'title',
  TRACK_QUANTITY: 'trackQuantity',
  UNIT: 'unit',
  VARIATIONS: 'variations',
  VENDOR: 'vendor',
  VIDEOS: 'videos',
  VISIBILITY: 'visibility',
  WEIGHT: 'weight',
  WEIGHT_MAJOR: 'weightMajor',
  WEIGHT_MINOR: 'weightMinor',
  WHEN_MADE: 'whenMade',
  WHO_MADE: 'whoMade',
  WHOLESALE_PRICE: 'wholesalePrice',
  WIDTH: 'width',
};
